import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/Logo.png'
import Services from '../../api/Services';
import './cta.css'


// images
import instragram1 from '../../images/instragram/1.jpg'
import instragram2 from '../../images/instragram/2.jpg'
import instragram3 from '../../images/instragram/3.jpg'
import instragram4 from '../../images/instragram/4.jpg'
import instragram5 from '../../images/instragram/5.jpg'
import instragram6 from '../../images/instragram/6.jpg'

const instragram = [
    {
        id: '1',
        img: instragram1,
    },
    {
        id: '2',
        img: instragram2,
    },
    {
        id: '3',
        img: instragram3,
    },
    {
        id: '4',
        img: instragram4,
    },
    {
        id: '5',
        img: instragram5,
    },
    {
        id: '6',
        img: instragram6,
    }
]

const ClickHandler = () => {
    window.scrollTo(10, 0);
}


const Footer = (props) => {

    
    return (
        <footer className="wpo-site-footer">
            <div className={`wpo-upper-footer ${props.ftClass}`}>
                <div className="container">
                    <div className="row">
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <div className="logo">
                                      <Link onClick={ClickHandler} className="navbar-brand" to="/"><img src={Logo} alt="" /></Link>  
                                    </div>
                                </div>
                                
                                <ul>
                                    <li>
                                        <Link to='/' onClick={ClickHandler}>
                                            <i className="ti-facebook"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/' onClick={ClickHandler}>
                                            <i className="ti-twitter-alt"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/' onClick={ClickHandler}>
                                            <i className="ti-instagram"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='/' onClick={ClickHandler}>
                                            <i className="ti-google"></i>
                                        </Link>
                                    </li>
                                
                                </ul>
                                
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Our Services</h3>
                                </div>
                                <ul>
                                    {Services.slice(0, 4).map((service, Sitem) => (
                                        <li key={Sitem}><Link onClick={ClickHandler} to={`/${service.link}`}>{service.title}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Our Services</h3>
                                </div>
                                <ul>
                                    {Services.slice(4, 8).map((service, Sitem) => (
                                        <li key={Sitem}><Link onClick={ClickHandler} to={`/${service.link}`}>{service.title}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>Contact </h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-maps-and-flags"></i>No. 19, Nisarga Layout,<br/> Anantapura, Yelahanka,<br/> Bengaluru - 560064</li>
                                        <li><i className="fi flaticon-phone-call"></i>91 96632 22146 <br />
                                            </li>
                                        <li><i className="fi flaticon-email"></i>info@yatriinteriors.in</li>
                                        <li> <a href="/company-profile.pdf" target="_blank" rel="noopener noreferrer"> Company Profile</a></li> 

                                    </ul>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>&copy; 2025 YATRI INTERIORS All Rights Reserved. Design Hosted By <Link to='https://webuniversals.co.in' onClick={ClickHandler}>Web Universals</Link>
                                    </li>
                                <li><Link to='/termsconditions' onClick={ClickHandler}>Terms &amp; Conditions |</Link>
                                    <Link to='/privacypolicy' onClick={ClickHandler}> Privacy Policy</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mobile-cta">
  <a href="tel:919663222146" className="cta-button">
    Call Now: +91 96632 22146
  </a>
</div>
        </footer>

    )
}

export default Footer;






